// Permissions added directly to a space (not inherited from parent/orgs/projects)
export var DirectSpaceAccessOrigin;
(function (DirectSpaceAccessOrigin) {
    DirectSpaceAccessOrigin["USER_ACCESS"] = "user_access";
    DirectSpaceAccessOrigin["GROUP_ACCESS"] = "group_access";
})(DirectSpaceAccessOrigin || (DirectSpaceAccessOrigin = {}));
export var ProjectSpaceAccessOrigin;
(function (ProjectSpaceAccessOrigin) {
    ProjectSpaceAccessOrigin["PROJECT_MEMBERSHIP"] = "project_membership";
    ProjectSpaceAccessOrigin["GROUP_MEMBERSHIP"] = "group_membership";
})(ProjectSpaceAccessOrigin || (ProjectSpaceAccessOrigin = {}));
export var SpaceMemberRole;
(function (SpaceMemberRole) {
    SpaceMemberRole["VIEWER"] = "viewer";
    SpaceMemberRole["EDITOR"] = "editor";
    SpaceMemberRole["ADMIN"] = "admin";
})(SpaceMemberRole || (SpaceMemberRole = {}));
//# sourceMappingURL=space.js.map